/**
 * LDM · Casos de uso — ajuste del riel
 * ---------------------------------------------------------------------------
 * El marquee se mueve con CSS; esto solo dimensiona el riel.
 *
 * El bucle nunca falló por posición: copias idénticas con un desplazamiento de
 * una copia cierran el ciclo exacto. Fallaba por memoria de vídeo. El riel medía
 * 4272px de ancho y llevaba `will-change: transform`, que lo promueve a una
 * capa de GPU permanente; buena parte de los móviles no admite texturas de más
 * de 4096px, así que la capa no cabía, el navegador no lograba pintarla y la
 * sección quedaba en blanco hasta que conseguía rehacerla.
 *
 * Aquí el riel se ajusta a las copias que la pantalla necesita de verdad: en un
 * teléfono bastan tres —poco más de 2000px— donde antes había seis. Se quitan
 * las que sobran y se reponen si la ventana se ensancha o el teléfono gira, de
 * modo que nunca falte contenido por la derecha.
 *
 * De paso fija el desplazamiento en píxeles. El porcentaje obligaba a medir
 * contra un ancho `max-content`, que es justo lo que Safari resuelve mal y por
 * lo que se había puesto `will-change` en su día. Con el ancho medido aquí, esa
 * propiedad ya no hace falta y la capa gigante desaparece con ella.
 */
(function () {
  'use strict';

  // Tope de seguridad: si una medida saliera absurda, esto evita clonar sin fin.
  var MAX_COPIAS = 20;

  /**
   * Copia limpia del grupo, lista para repetir. Los atributos del editor de
   * temas se retiran: solo deben existir en el grupo original, o el editor
   * mostraría el mismo bloque varias veces.
   */
  function plantilla(track) {
    if (track.ldmPlantilla) return track.ldmPlantilla;

    var base = track.querySelector('.ldm-uc__group');
    if (!base) return null;

    var copia = base.cloneNode(true);
    copia.setAttribute('aria-hidden', 'true');

    var conAtributos = copia.querySelectorAll('[data-shopify-editor-block]');
    Array.prototype.forEach.call(conAtributos, function (el) {
      el.removeAttribute('data-shopify-editor-block');
    });
    copia.removeAttribute('data-shopify-editor-block');

    track.ldmPlantilla = copia;
    return copia;
  }

  function ajustar(row) {
    var track = row.querySelector('.ldm-uc__track');
    if (!track) return;

    var grupos = track.querySelectorAll('.ldm-uc__group');
    if (!grupos.length) return;

    var anchoGrupo = grupos[0].getBoundingClientRect().width;
    var anchoRow = row.getBoundingClientRect().width;
    // Sin medidas todavía (sección oculta, fuentes sin cargar): no se toca nada.
    if (anchoGrupo < 1 || anchoRow < 1) return;

    // En cada ciclo se va una copia por la izquierda: hay que cubrir la fila
    // entera más esa copia, y se guarda una de colchón.
    var necesarias = Math.min(Math.ceil(anchoRow / anchoGrupo) + 2, MAX_COPIAS);
    var modelo = plantilla(track);

    while (track.querySelectorAll('.ldm-uc__group').length < necesarias && modelo) {
      track.appendChild(modelo.cloneNode(true));
    }

    grupos = track.querySelectorAll('.ldm-uc__group');
    for (var i = grupos.length - 1; i >= necesarias; i--) {
      grupos[i].parentNode.removeChild(grupos[i]);
    }

    row.style.setProperty('--ldm-uc-shift', anchoGrupo + 'px');
  }

  function init() {
    var filas = document.querySelectorAll('.ldm-uc__row');

    Array.prototype.forEach.call(filas, function (row) {
      requestAnimationFrame(function () {
        ajustar(row);
      });

      if (typeof ResizeObserver === 'function' && !row.ldmObservado) {
        row.ldmObservado = true;
        // Al girar el teléfono o redimensionar cambia el ancho de la fila y con
        // él el número de copias necesarias.
        new ResizeObserver(function () {
          ajustar(row);
        }).observe(row);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
